import React from 'react';

const Footer = () => {
 return (
  <div>
   <p class="author"> &#129680; by <a href="https://github.com/cruzito-rar" target="blank"> cruzito.rar </a> </p>
  </div>
 )
}

export default Footer;